type BarChartSkeletonProps = {
  length?: number;
};

const BarChartSkeleton = (_props: BarChartSkeletonProps) => {
  return (
    <></>
    // <Card className="h-100">
    //   <FalconCardHeader
    //     title={
    //       <div>
    //         درحال بارگذاری
    //         <HelpTooltip html="درحال بارگذاری" />
    //       </div>
    //     }
    //     titleTag="h6"
    //     className="py-3"
    //     light
    //   />
    //   <Card.Body
    //     as={Flex}
    //     direction="column"
    //     justifyContent="between"
    //     className="py-2"
    //   >
    //     <div
    //       style={{ height: 250 }}
    //       className="d-flex align-items-end gap-2 justify-content-around"
    //     >
    //       {Array.from({ length }).map((_, index) => (
    //         <Placeholder
    //           style={{ height: Math.floor(Math.random() * 100) + '%' }}
    //           size="md"
    //           as="div"
    //           className="flex-1"
    //           key={index}
    //         />
    //       ))}
    //     </div>
    //   </Card.Body>
    // </Card>
  );
};

export default BarChartSkeleton;
